import { PassportTabsEnum } from '../enums/PassportTabsEnum';

export const pmPreviewHeaderTabs: Array<{ name: PassportTabsEnum; text: string }> = [
  {
    name: PassportTabsEnum.COMMON,
    text: 'Общая информация',
  },
  {
    name: PassportTabsEnum.CONTROL,
    text: 'Информация об органе контроля',
  },
  {
    name: PassportTabsEnum.FACE,
    text: 'Сведения о контролируемом лице',
  },
  {
    name: PassportTabsEnum.RESULT,
    text: 'Список результатов',
  },
  {
    name: PassportTabsEnum.VIOLATION,
    text: 'Список выявленных нарушений',
  },
];
